import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import {BranchService } from '@app/_services/masters/branch.service';
import { branch } from '@app/_models/branch';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-branch-master-edit',
  templateUrl: './branch-master-edit.component.html',
  styleUrls: ['./branch-master-edit.component.css']
})
export class BranchMasterEditComponent implements OnInit {

  brnchId: number;
  editBranchForm: FormGroup;
  branch: branch[];
  submitted = false;
  branchName: string;
  response: any;
  branchId: number;
  getresponse: any;
  strMessage:string;
  streamDropDown = [];
  streamId: number;

  get f() { return this.editBranchForm.controls; }

  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private branchService: BranchService,
    private modalService: NgbModal, private verifyDocService: VerifyDocumentService,config: NgbModalConfig) { }

  @Input() childMessage: branch[];

  receiveDocumentId(p) {
    this.brnchId = p;
  }

  ngOnInit(): void {
    
    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;
    this.branchName = this.response.branchName;
    this.branchId = this.response.id;
    this.streamId = this.response.streamId;

    this.editBranchForm = this.formBuilder.group({
      branchName: ['', Validators.required],
      streamId: ['', Validators.required]
    });

    this.verifyDocService.getStreams()
    .pipe(first())
    .subscribe(
      data => {
        this.streamDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )
  }

  updateBranch() {
    this.submitted = true;

    if (this.editBranchForm.invalid) {
      return;
    }
    var v = new branch();
    v.branchname = this.branchName;
    v.id = this.branchId;
    v.streamid = this.streamId;
    this.branchService.updateBranch(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="Branch Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        
        else if (this.getresponse.respMessage == "Failure") {
          this.strMessage=this.getresponse.respData;
          this.modalService.open(this.showModalBoxTemplate);
          var v = response;
        }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('20');
  } 
  
  goBack()
  {
    this.eventService.emit<string>('20');
  }
}
